import { BazaarCounts } from 'mk2/apps/home/containers/Home/Home.reducers';
import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { Action } from 'redux';

export interface HomeLoadApiAction extends Action {
}

export const HOME_LOAD_API_REQUEST = 'HOME_LOAD_API_REQUEST';

export interface HomeLoadApiRequestAction extends HomeLoadApiAction, APIRequestAction {
    readonly type: typeof HOME_LOAD_API_REQUEST;
}

export const HOME_LOAD_API_SUCCESS = 'HOME_LOAD_API_SUCCESS';

export interface HomeLoadApiSuccessAction extends HomeLoadApiAction, APISuccessAction {
    readonly type: typeof HOME_LOAD_API_SUCCESS;
    readonly nextPage: number | null;
    readonly bazaarCounts: BazaarCounts;
    readonly lastVisitCountFriends: string;
}

export const HOME_LOAD_API_FAILURE = 'HOME_LOAD_API_FAILURE';

export interface HomeLoadApiFailureAction extends HomeLoadApiAction, APIFailureAction {
    readonly type: typeof HOME_LOAD_API_FAILURE;
}

export const homeLoadApi = {
    request: (): HomeLoadApiRequestAction => ({ type: HOME_LOAD_API_REQUEST }),
    success: (nextPage: number | null, bazaarCounts: BazaarCounts, lastVisitCountFriends: string, response: any): HomeLoadApiSuccessAction => ({
        type: HOME_LOAD_API_SUCCESS,
        nextPage, bazaarCounts, lastVisitCountFriends,
        response,
    }),
    failure: (error: any): HomeLoadApiFailureAction => ({ type: HOME_LOAD_API_FAILURE, error }),
};

export const HOME_LOAD = 'HOME_LOAD';

export interface HomeLoadAction extends Action {
    readonly type: typeof HOME_LOAD;
}

export const homeLoad = (): HomeLoadAction => ({ type: HOME_LOAD });

export interface HomeLoadPageApiAction extends Action {
    readonly page: number;
}

export const HOME_LOAD_PAGE_API_REQUEST = 'HOME_LOAD_PAGE_API_REQUEST';

export interface HomeLoadPageApiRequestAction extends HomeLoadPageApiAction, APIRequestAction {
    readonly type: typeof HOME_LOAD_PAGE_API_REQUEST;
}

export const HOME_LOAD_PAGE_API_SUCCESS = 'HOME_LOAD_PAGE_API_SUCCESS';

export interface HomeLoadPageApiSuccessAction extends HomeLoadPageApiAction, APISuccessAction {
    readonly type: typeof HOME_LOAD_PAGE_API_SUCCESS;
    readonly nextPage: number | null;
}

export const HOME_LOAD_PAGE_API_FAILURE = 'HOME_LOAD_PAGE_API_FAILURE';

export interface HomeLoadPageApiFailureAction extends HomeLoadPageApiAction, APIFailureAction {
    readonly type: typeof HOME_LOAD_PAGE_API_FAILURE;
}

export const homeLoadPageApi = {
    request: (page: number): HomeLoadPageApiRequestAction => ({ type: HOME_LOAD_PAGE_API_REQUEST, page }),
    success: (page: number, nextPage: number | null, response: any): HomeLoadPageApiSuccessAction => ({ type: HOME_LOAD_PAGE_API_SUCCESS, page, nextPage, response }),
    failure: (page: number, error: any): HomeLoadPageApiFailureAction => ({ type: HOME_LOAD_PAGE_API_FAILURE, page, error }),
};

export const HOME_LOAD_PAGE = 'HOME_LOAD_PAGE';

export interface HomeLoadPageAction extends HomeLoadPageApiAction {
    readonly type: typeof HOME_LOAD_PAGE;
}

export const homeLoadPage = (page: number): HomeLoadPageAction => ({ type: HOME_LOAD_PAGE, page });

export interface HomeSuggestArticleApiAction extends Action {
}

export const HOME_SUGGEST_ARTICLE_API_REQUEST = 'HOME_SUGGEST_ARTICLE_API_REQUEST';

export interface HomeSuggestArticleApiRequestAction extends HomeSuggestArticleApiAction, APIRequestAction {
    readonly type: typeof HOME_SUGGEST_ARTICLE_API_REQUEST;
}

export const HOME_SUGGEST_ARTICLE_API_SUCCESS = 'HOME_SUGGEST_ARTICLE_API_SUCCESS';

export interface HomeSuggestArticleApiSuccessAction extends HomeSuggestArticleApiAction, APISuccessAction {
    readonly type: typeof HOME_SUGGEST_ARTICLE_API_SUCCESS;
}

export const HOME_SUGGEST_ARTICLE_API_FAILURE = 'HOME_SUGGEST_ARTICLE_API_FAILURE';

export interface HomeSuggestArticleApiFailureAction extends HomeSuggestArticleApiAction, APIFailureAction {
    readonly type: typeof HOME_SUGGEST_ARTICLE_API_FAILURE;
}

export const homeSuggestArticleApi = {
    request: (): HomeSuggestArticleApiRequestAction => ({
        type: HOME_SUGGEST_ARTICLE_API_REQUEST,
    }),
    success: (response: any): HomeSuggestArticleApiSuccessAction => ({
        type: HOME_SUGGEST_ARTICLE_API_SUCCESS,
        response,
    }),
    failure: (error: any): HomeSuggestArticleApiFailureAction => ({
        type: HOME_SUGGEST_ARTICLE_API_FAILURE,
        error,
    }),
};

export const HOME_SUGGEST_ARTICLE = 'HOME_SUGGEST_ARTICLE';

export interface HomeSuggestArticleAction extends HomeSuggestArticleApiAction {
    readonly type: typeof HOME_SUGGEST_ARTICLE;
}

export const homeSuggestArticle = (): HomeSuggestArticleAction => ({
    type: HOME_SUGGEST_ARTICLE,
});
